"use strict";
module.exports = global.process || require('../../compiled/process');

//# sourceMappingURL=process.js.map